import './components/styles/mdc-styles.scss'
import './components/styles/button-styles.scss'
import './components/styles/ag-grid-styles.scss'
import './components/styles/react-datepicker-styles.scss'
import './components/styles/NotifyStyles.scss'

import React from 'react'
import ReactDOM from 'react-dom'
import {Provider} from 'react-redux'
import {applyMiddleware, compose, createStore} from 'redux'
import thunk from 'redux-thunk'

import reducer from './state/combinedReducers'
import {getGlobalStore, setGlobalStore} from './state/globalStore'
import AppComponent from './components/AppComponent'
import './splitting/axiosSetup'

import {mochpBootstrap} from './mochpBoostrap'
import {setMocCheckResponse} from "./state/app/actions"

const composeWithDevExtensions =
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
        : compose

setGlobalStore(
    createStore(
        reducer,
        composeWithDevExtensions(applyMiddleware(thunk))
    )
)

mochpBootstrap()
.then(function (mocCheckResponse) {
  getGlobalStore().dispatch(
      setMocCheckResponse(mocCheckResponse)
  )
})
.finally(function () {
  ReactDOM.render(
      <Provider store={getGlobalStore()}>
        <AppComponent />
      </Provider>,
      document.getElementById('lalb')
  )
})